import { useSendAnalyticsEvent } from './use-send-event';
import { useEffect, useRef } from 'react';

const postHogEventName = 'pvo_time_spent';

export const useTrackTimeSpent = () => {
  const { sendEvent } = useSendAnalyticsEvent();
  const startTimeRef = useRef(Date.now());
  const hasSentEventRef = useRef(false);

  const sendTimeEvent = () => {
    if (hasSentEventRef.current) return;

    const totalTimeSpent = Date.now() - startTimeRef.current;
    const timeSpentSeconds = Math.round(totalTimeSpent / 1000);

    sendEvent(postHogEventName, {
      time_spent_seconds: timeSpentSeconds,
    });

    hasSentEventRef.current = true;
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      sendTimeEvent();
    };

    const handlePageHide = () => {
      sendTimeEvent();
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        sendTimeEvent();
      } else if (!document.hidden) {
        hasSentEventRef.current = false;
        startTimeRef.current = Date.now();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('pagehide', handlePageHide);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('pagehide', handlePageHide);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [sendEvent]);
};
